import { memberCommonConfig } from './common'
import type { MemberPageConfig } from './types'

export const theme = {
  avatarBorder: '#8E47FF',
  btnPrimaryBg: 'rgba(166, 107, 255, 0.12)',
  topUpBtnBg: 'linear-gradient(90deg, #A66BFF 0%, #8E47FF 100%)',
  vipSubscribeBg: 'url(/images/novaris/member_subscribe_bg.webp)',
  subscribeBg: 'linear-gradient(100deg, #3D2A5C 0%, #332247 58%, #2A1B3D 100%)',
  subscribeText: '#C7A7FF',
  subscribeText2: 'rgba(199, 167, 255, 0.6)',

  userDefaultAvatar: '/images/novaris/user-default.svg?v=3',
  memberVip: '/images/novaris/member-vip.png',
  memberVipDiscount: '/images/novaris/member-vip-discount.png',
} as const

export const resources = {
  memberBg: '',
  userBg: '',
  userDefaultAvatar: '/images/novaris/user-default.svg?v=3',
  memberVip: '/images/novaris/member-vip.png',
  memberVipDiscount: '/images/novaris/member-vip-discount.png',
} as const

export const memberConfig: MemberPageConfig = {
  theme,
  resources,
  texts: {
    ...memberCommonConfig.texts,
    vipTitle: 'Unlock Novaris VIP',
    vipSubtitle: 'Get more coins and premium reading perks.',
  },
}
